export default (file) => ({
    loadingMedia: true,
    imageLoaded() {
        this.loadingMedia = false;
    },
    videoLoaded() {
        this.loadingMedia = false;
    },
    init() {
        this.$watch('loadingMedia', (value) => {
            if (!value) {
                document.getElementById(`loading-${file.id}`)?.remove();
            }
        });
    }
})
